import type { GfaLocaleServiceV1 } from '@volkswagen-onehub/gfa-locale-service';
import type { FC, PropsWithChildren } from 'react';
import React, { createContext, useMemo } from 'react';
import type { CarlineGroup } from '../../@types/mapped';
import { fetchCarlineGroups } from '../utils/fetchCarlineGroups';
import { useContent } from './ContentContext';
import { filterNonConfigurableCarlines } from './compareContextUtils';

export type DataContextState = {
  readonly allCarlineGroups: CarlineGroup[];
};

export const DataContext = createContext<DataContextState>({
  allCarlineGroups: [],
});

export type DataContextProviderProps = {
  readonly localeService: GfaLocaleServiceV1;
};

export const DataContextProvider: FC<PropsWithChildren<DataContextProviderProps>> = ({
  localeService,
  children,
}) => {
  const { compareMode } = useContent();
  const allCarlineGroups = fetchCarlineGroups(localeService.countryCode, localeService.language);
  const state: DataContextState = useMemo(() => {
    const filteredCarlines =
      compareMode !== 'compare-only'
        ? allCarlineGroups
        : filterNonConfigurableCarlines(allCarlineGroups);
    return {
      allCarlineGroups: filteredCarlines,
    };
  }, [allCarlineGroups, compareMode]);

  return <DataContext.Provider value={state}>{children}</DataContext.Provider>;
};
